export const iconFontAwesomeShoppingNfcDirectional = (
	<i className="fa-solid fa-nfc-directional"></i>
);
